// frontend/src/components/common/InfoHint.jsx
//
// An info icon whose only content is its hover tooltip. Where the primary
// pointer cannot hover — a phone, a tablet — nothing opens the tooltip, so
// the icon is not drawn there (InfoHint.css). The icon is one em of the
// surrounding text; `className` places or resizes it for its spot.

import { Tooltip } from '@mui/material';
import { Info } from '../../icons';
import './InfoHint.css';

export default function InfoHint({ text, className }) {
  return (
    <Tooltip title={text}>
      <Info className={className ? `info-hint ${className}` : 'info-hint'} />
    </Tooltip>
  );
}
